import { BaseDataService } from './BaseDataService';
import { CharacteristicScore, SurveyVersion } from '../../models';
import { NotificationService } from '../../services';

export class CharacteristicScoreDataService extends BaseDataService<CharacteristicScore> {
    constructor(notificationService: NotificationService) {
        super('CharacteristicScore', 'CharacteristicScores', notificationService);
    }

    public getAllBySurveyVersion(surveyVersion: SurveyVersion): Promise<any> {
        const endpoint = `${this.endpointRoot}/bysurveyversion/${surveyVersion.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving characteristic scores.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/CharacteristicScoreData.tsx